import React from 'react'
import { Link } from 'react-router-dom'
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      // { name: 'Careers', path: '/careers' },
    ],
    services: [
      { name: 'Nuclear Medicine', path: '/services#nuclear' },
      { name: 'CAT Scan', path: '/services#catscan' },
      { name: 'Ultrasound', path: '/services#ultrasound' },
    ],
    support: [
      { name: 'AI Agent Support', path: '/support' },
      { name: 'Contact Us', path: '/contact' },
    ],
    legal: [
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
      { name: 'Cookie Policy', path: '/cookies' },
      { name: 'GDPR Compliance', path: '/gdpr' },
    ],
  }

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
    { icon: Instagram, href: '#', label: 'Instagram' },
  ]

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main footer content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-accent-400 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">M</span>
              </div>
                              <div>
                  <h3 className="text-xl font-bold">South Hampton</h3>
                  <p className="text-sm text-gray-400">Medical Imaging</p>
                </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Leading provider of advanced ultrasound and radiology technology, 
              empowering healthcare professionals with cutting-edge diagnostic solutions.
            </p>
            
            {/* Contact info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary-400" />
                <span className="text-gray-300">(713) 797-0900</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary-400" />
                <span className="text-gray-300">shmillc23@gmail.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="w-5 h-5 text-primary-400" />
                <span className="text-gray-300">7707 Fannin St SUITE 159, Houston, TX 77054</span>
              </div>
            </div>
          </div>

          {/* Company links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
                         <ul className="space-y-2">
               {footerLinks.company.map((link) => (
                 <li key={link.name}>
                   <Link 
                     to={link.path}
                     className="text-gray-300 hover:text-primary-300 transition-colors duration-200"
                   >
                     {link.name}
                   </Link>
                 </li>
               ))}
             </ul>
          </div>

          {/* Services links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
                         <ul className="space-y-2">
               {footerLinks.services.map((link) => (
                 <li key={link.name}>
                   <Link 
                     to={link.path}
                     className="text-gray-300 hover:text-primary-300 transition-colors duration-200"
                   >
                     {link.name}
                   </Link>
                 </li>
               ))}
             </ul>
          </div>

          {/* Support links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Support</h4>
                         <ul className="space-y-2">
               {footerLinks.support.map((link) => (
                 <li key={link.name}>
                   <Link 
                     to={link.path}
                     className="text-gray-300 hover:text-primary-300 transition-colors duration-200"
                   >
                     {link.name}
                   </Link>
                 </li>
               ))}
             </ul>
          </div>
        </div>


      </div>
    </footer>
  )
}

export default Footer 